<template>
    <div style="padding:30px">
        <div class="my-title">
            我的订单
        </div>
        <div class="nav F-flex">
            <div class="tag flex">
                <div
                    v-for="(item, index1) in orderState"
                    :key="index1"
                    @click="click(item.type, 'type')"
                    :class="{ 'type-true': type == item.type }"
                >
                    {{ item.title }}
                </div>
            </div>
            <div class="search">
                <el-input
                    placeholder="请输入内容"
                    v-model="kw"
                    class="input-with-select"
                >
                    <div slot="append" @click="lists">查询</div>
                </el-input>
            </div>
        </div>
        <div class="order-title">
            <el-row>
                <el-col :span="14">
                    <div>订单详情</div>
                </el-col>
                <el-col :span="5">
                    <div>状态</div>
                </el-col>
                <el-col :span="5">
                    <div style="color:#D42D25;">操作</div>
                </el-col>
            </el-row>
        </div>
        <div class="order-item" v-for="(item, index2) in orderData" :key="index2">
            <div class="order-line">
                <span>{{ item.time }}</span>
                <span style="margin-left: 20px;"
                    >订单号：{{ item.order_sn }}</span
                >
            </div>
            <div class="order-line" style="color:#999999">
                支付方式：在线支付 订单总额：￥{{
                    item.total_amount
                }}
                运费总额：￥{{item.dispatch_amount}} 订单状态：{{ item.status_name }}
            </div>
            <div class="order-goods">
            <el-row style="display: flex;flex-direction: column;align-items: stretch;">
                <div v-for="(items, index) in item.item" :key="'info-'+ index" >
                    <el-col :span="10">
                        <div
                            class="flex order-goods-con"
                            @click="onOrderId(item.item[0].goods_id)">
                            <div class="flex ali-cen">
                                <img :src="items.goods_image" alt="" />
                                <div>
                                    <div>{{ items.goods_title }}</div>
                                    <div>{{ items.goods_sku_text }}</div>
                                </div>
                            </div>
                            <div>x{{ items.goods_num }}</div>
                        </div>
                    </el-col>
                    <el-col :span="4" style="height:107px">
                        <div class="flex ali-cen jus-cen goods-type">
                            ¥{{ items.goods_price }}
                        </div>
                    </el-col>


                </div>
                <div class="more_btn_detail">
 <div
                            class="flex flex-column ali-cen jus-cen goods-type"
                        >
                            <div style="color: #FF6701;margin-bottom:10px">
                                {{ item.item[0].status_name }}
                            </div>
                            <div @click="viewOrder(item.id)">查看订单详情</div>
                        </div>
                </div>
                <div class="more_btn_m">

                        <div
                            class="flex flex-column ali-cen jus-cen goods-type"
                            style="border: none;"
                        >
                            <div v-for="orderBtn in item.btns" :key="orderBtn">
                                <!-- <div class="order-btn" @click="onConfrim(item.id,item.item[0].id)">
									确认收货
								</div> -->

                                <div
                                    class="order-btn"
                                    v-if="orderBtn === 'pay'"
                                    @click="onPay(item.id)"
                                >
                                    支付
                                </div>
                                <div
                                    v-if="orderBtn === 'cancel'"
                                    class="order-btn"
                                    style="background-color: #D6D6D6;color: #666666;"
                                    @click="onCanel(item.id)"
                                >
                                    取消订单
                                </div>
                                <div
                                    v-if="orderBtn === 'delete'"
                                    class="order-btn"
                                    style="background-color: #D6D6D6;color: #666666;"
                                    @click="onDelete(item.id)"
                                >
                                    删除
                                </div>
                                <div
                                    v-if="orderBtn === 'express'"
                                    class="order-btn"
                                    style="background-color: #D6D6D6;color: #666666;"
                                    @click="viewOrder(item.id)"
                                >
                                    查看物流
                                </div>
                            </div>
                        </div>
                </div>
            </el-row>
            </div>
        </div>

        <!-- 分页 -->
        <div class="shopp_pagination">
            <el-button
                size="small"
                style="width: 80px;height: 40px;"
                @click="pervious"
                >上一页</el-button
            >
            <el-pagination
                ref="pageGroup"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
                background
                layout="pager"
                :total="list.length"
            >
            </el-pagination>
            <el-button
                style="width: 80px;height: 40px;"
                size="small"
                @click="next"
                >下一页</el-button
            >
        </div>
    </div>
</template>
<script>
import { orderIndex, orderConfirm,orderCanel,orderDelete } from "@/api/index.js";
import { timestampToTime } from "../../../../util/util.js";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    data() {
        return {
            list: [],
            kw: "",
            page: {},
            type: "all",
            orderState: [
                {
                    id: 0,
                    title: "全部",
                    type: "all"
                },
                {
                    id: 1,
                    title: "待付款",
                    type: "nopay"
                },
                {
                    id: 2,
                    title: "待发货",
                    type: "nosend"
                },
                {
                    id: 3,
                    title: "待收货",
                    type: "noget"
                },
                {
                    id: 4,
                    title: "待评价",
                    type: "nocomment"
                }
            ],
            currentPage: 1,
            pageSize: 3,
            total: 1
        };
    },
    methods: {
        lists() {
            orderIndex(
                { type: this.type, page: this.current, kw: this.kw },
                header
            ).then(res => {
                if (res.code == 1) {
                    res.data.data.forEach(i => {

                        i.time = timestampToTime(i.createtime * 1000);

                    });
                    this.list = res.data.data;
                    console.log(res.data);
                    this.total = res.data.total;
                    this.page = res.data;
                }
            });
        },
        viewOrder(e) {
            // this.$emit("checkView", {
            //     menuId: 16,
            //     data: { orderId: e }
            // });
            console.log(e);
            this.$router.push({path:'/ods',query:{orderId: e}})
        },
        onExpress(e){
        this.$emit("checkView", {
                menuId: 16,
                data: { orderId: e }
            });
        },
        click(e, type) {
            this[type] = e;
            this.lists();
        },
        onConfrim(id, itemId) {
            orderConfirm({ id: id, order_item_id: itemId }, header).then(
                res => {
                    if (res.code == 1) {
                        this.lists();
                    }
                }
            );
        },
        //上一页
        pervious() {
            this.$refs.pageGroup.prev();
        },
        //下一页
        next() {
            this.$refs.pageGroup.next();
        },
        handleCurrentChange(newNum) {
            this.currentPage = newNum;
        },
        //删除订单
        async onDelete(roderId) {
            const removeResult = await this.$confirm(
                "确认要删除订单吗?",
                "提示",
                {
                    confirmButtonText: "删除",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            ).catch(err => err);
            if (removeResult !== "confirm") {
                return;
            }
            orderDelete({ id: roderId }, header).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.lists();
            });
        },
        //取消订单
        onCanel(id){
            orderCanel({id:id},header).then(res=>{
                console.log(res);
                if(res.code !== 1){
                return
                }
            this.lists()
            })

        },
        //立即购买
        onPay(id){
        this.$router.push({name:'pay',query: {id:id}})
        },
        //点击进入详情页
        onOrderId(id){
        this.$router.push({path:'/info',query:{id:id}})
        }
    },
    created() {
        this.lists();
    },

    computed: {
        orderData: function() {
            return this.list.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize
            );
        }
    }
};
</script>
<style lang="less" scoped>
.el-input-group__append {
    background-color: #ff6701;
    color: #fff !important;
}
.el-row {
    display: flex;
    align-items: center;
}
.my-title {
    // height: 40px;
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
}
.nav {
    width: 100%;
    .tag {
        div {
            margin-right: 30px;
            font-size: 16px;
        }
        .type-true {
            color: #ff6701;
            border-bottom: solid 2px #ff6701;
        }
    }
}
.order-title {
    background-color: #f5f5f5;
    line-height: 45px;
    height: 45px;
    margin: 20px 0;
    div {
        text-align: center;
    }
}
.order-item {
    border: 1px solid #cdcdcd;
    margin-bottom: 20px;
    .order-line {
        height: 55px;
        line-height: 55px;
        background-color: #f5f5f5;
        padding: 0 30px;
        border-bottom: 1px solid #cdcdcd;
    }
}
.order-goods {
    .order-goods-con {
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        align-items: center;
        img {
            width: 97px;
            height: 97px;
            // margin-right: 10px;
            margin: 5px 15px 5px 0;
        }
    }
    .goods-type {
        height: 100%;
        // border-right: solid 1px #cdcdcd;
    }
}
.order-btn {
    width: 98px;
    height: 32px;
    background: #ff6701;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    margin-bottom: 5px;

}
.shopp_pagination {
    width: 875px;
    display: flex;
    justify-content: center;
    margin-top: 60px;
}
.el-pagination {
    padding: 0;
}
/deep/ .el-pager li {
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
}
.more_btn_m{
    position: absolute;
    top: 50%;
    right: 44px;
    transform: translate(0%, -50%);
}
.more_btn_detail{
     position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
    right: 230px;
     height: 100%;
    /* border: 1px solid; */
    border-right: solid 1px #cdcdcd;
    border-left: solid 1px #cdcdcd;
    width: 17%;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/order.vue